import * as React from "react";
import { IconProps } from "./types";

export const AlignJustifyIcon = React.forwardRef<SVGSVGElement, IconProps>(
  ({ color = "currentColor", ...props }, forwardedRef) => {
    return (
      <svg
        fill="none"
        height="24"
        viewBox="0 0 24 24"
        width="24"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
        ref={forwardedRef}
      >
        <path
          d="M21 10H3M21 18H3M21 6H3M21 14H3"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
          stroke={color}
        />
      </svg>
    );
  },
);
(AlignJustifyIcon as React.FunctionComponent).displayName = "AlignJustifyIcon";

export default AlignJustifyIcon;
